var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPokal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.306,
    height: 259.672,
    viewBox: "0 0 211.306 259.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M64,194.125a27.017,27.017,0,1,0,27.017-26.8A26.907,26.907,0,0,0,64,194.125",
    transform: "translate(-64 -167.327)",
    fill: "#5b5b5b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_13",
    x: 0,
    y: 0,
    width: 85.342,
    height: 80.394,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-101 -207.328)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(21 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(81 233.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 113,
    height: 21,
    transform: "translate(49 203.789)",
    fill: "#474e5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 6,
    height: 21,
    transform: "translate(64 203.789)",
    fill: "#606776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 23,
    height: 21,
    transform: "translate(139 203.789)",
    fill: "#2e3544"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 98,
    height: 7,
    transform: "translate(56 196.789)",
    fill: "#474e5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 8,
    height: 7,
    transform: "translate(70 196.789)",
    fill: "#606776"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 21,
    height: 7,
    transform: "translate(133 196.789)",
    fill: "#2e3544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M244.082,356a59.56,59.56,0,0,0,39.533,56.083l2.528,3.5H188l2.5-3.5A59.547,59.547,0,0,0,230.061,356Z",
    transform: "translate(-131.918 -219.301)",
    fill: "#ffca10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M351.68,412.083A59.56,59.56,0,0,1,312.147,356h-3c0,25.863,9.423,47.852,22.59,56.083l1.445,3.5h21.031Z",
    transform: "translate(-199.984 -219.301)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M266.867,363.994a66.434,66.434,0,0,1-25.659,49.074h6.449c12.235-12.673,18.531-31.062,19.235-49.074Z",
    transform: "translate(-161.814 -223.793)",
    fill: "#ffff74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M282.184,44H156c0,77.432,28.247,140.2,63.092,140.2S282.184,121.432,282.184,44Z",
    transform: "translate(-113.939 -44)",
    fill: "#ffca10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M335.051,44c0,77.432-15.693,140.2-35.051,140.2,34.845,0,63.092-62.772,63.092-140.2Z",
    transform: "translate(-194.847 -44)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M186.2,60h-14.02c1,43.713,13.44,116.293,56,126.843C194.166,175.595,186.818,95.925,186.2,60Z",
    transform: "translate(-123.031 -52.99)",
    fill: "#ffff74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M430.767,44a25.3,25.3,0,0,0-16.716,6.3q-.127,6.4-.509,12.647a18.4,18.4,0,0,1,35.626,6.47c0,16.668-6.222,31.37-19.02,44.944-9.474,10.048-21.365,18.4-33.408,26.269a134.8,134.8,0,0,1-5.925,12.176c30.207-19.451,65.363-41.163,65.363-83.389A25.441,25.441,0,0,0,430.767,44Z",
    transform: "translate(-245.873 -44)",
    fill: "#ffca10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M119.461,140.679c-12.047-7.876-23.942-16.23-33.419-26.284C73.235,100.81,67.01,86.1,67.01,69.412a18.4,18.4,0,0,1,35.626-6.47q-.379-6.241-.509-12.647A25.392,25.392,0,0,0,60,69.412c0,42.283,35.215,64.007,65.4,83.453A134.679,134.679,0,0,1,119.461,140.679Z",
    transform: "translate(-60 -44)",
    fill: "#ffca10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(155.849 255.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M64,194.125a27.017,27.017,0,1,0,27.017-26.8A26.907,26.907,0,0,0,64,194.125",
    transform: "translate(-64 -167.327)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 54.033,
    height: 53.594,
    transform: "translate(0 0)",
    fill: "#5b5b5b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M137.173,182.334c-.138-2.846-1.522-5.455-4.81-5.3a3.779,3.779,0,0,0-3.765,3.923,3.387,3.387,0,0,0,1.45,2.724c.3,6.151-2.418,11.9-6.764,17.1a79.954,79.954,0,0,1-11.978,10.719,112.376,112.376,0,0,1-10.1,6.36l-2.516,1.382c8.456-11.566,8.389-26.449,13.849-35.969a15.492,15.492,0,0,1,5.044-5.046l-.315-.515c-13.427,5.1-34.781,6.435-34.781,17.777,0,4.143,3.3,6.248,7.226,6.248,5.715,0,8.09-4.529,8.09-9.624h-.774c0,4.017-1.859,8.476-6.161,8.476-3.086,0-4.305-2.232-4.305-4.909,0-10.43,19.914-13.371,26.05-15.92-12.527,9.958-13.377,21.921-16.12,32.387a48.935,48.935,0,0,1-5.438,12.018l.039.03c-.033.042-.065.086-.1.128l.18-.066.459.354c9.027-5.269,32.852-18.373,41.914-32.068,2.4-3.547,3.78-7.041,3.627-10.213",
    transform: "translate(-77.951 -174.649)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 101, 207.33)",
    filter: "url(#Path_13)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13",
    d: "M368.848,1069.988l11.694-23.794-7.3,25.3,25.214-11.155L375.582,1075.3l26.937,6.7-27.749-2.369,16.055,21.425-19.638-18.6-2.339,26.121-2.339-26.121-19.638,18.6,16.055-21.425-27.749,2.369,26.937-6.7-22.875-14.966,25.214,11.155-7.3-25.3Z",
    transform: "translate(-326.18 -1040.19)",
    fill: "#fff",
    opacity: 0.952
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokal);
export default __webpack_public_path__ + "static/media/pokal.6830573f966229975e4e05dc2b78abba.svg";
export { ForwardRef as ReactComponent };